<template>
  <v-dialog persistent v-model="dialogFollow" max-width="600px">
    <v-card>
      <v-card-title class="pb-0">
        <span class="gc-text-h6">{{
          `${lang.memoriesWall.follow} ${personMetrics.deceasedFullName}`
        }}</span>
      </v-card-title>
      <v-card-text class="pb-0 mb-0">
        <p class="caption grey--text">{{ lang.memoriesWall.w1 }}</p>
      </v-card-text>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" class="px-0 mx-0 pt-0">
              <div class="input-group">
                <label>{{ lang.fields.note }}</label>
                <textarea v-model="description" rows="4"></textarea>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          elevation="0"
          small
          text
          @click="closeDialogFollowPerson()"
        >
          {{ lang.actions.close }}
        </v-btn>
        <v-btn
          class="btn-bg"
          small
          elevation="0"
          :disabled="description == ''"
          @click="followPerson()"
        >
          {{ lang.actions.save }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "FollowDialog",
  data() {
    return {
      description: "",
    };
  },
  props: {
    personMetrics: {
      type: Object,
      default: null,
    },
    dialogFollow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    lang() {
      return this.$store.state.langObj || {};
    },
  },
  methods: {
    closeDialogFollowPerson() {
      this.$emit("closeDialogFollowPerson");
    },
    followPerson() {
      this.$emit("followPerson", this.description);
    },
  },
};
</script>
